import React, { PureComponent } from "react";

import { Popover, OverlayTrigger } from "react-bootstrap";
import moment from "moment";
import DatasetSchemaChangesContainer from "containers/SchemaMonitor/DatasetSchemaChanges";
import NumericLabel from "react-pretty-numbers";
import numeral from "numeral";

import styles from "./style.module.css";

import HomeIcon from "images/EDG/HomeIcon.svg";
import NumberIcon from "images/EDG/123.svg";
import CategoryIcon from "images/EDG/abc.svg";
import WarnIcon from "images/EDG/WarnIcon.svg";
import ShareIcon from "images/EDG/ShareIcon.svg";
import FlagIcon from "images/EDG/FlagIcon.svg";
import SettingsIcon from "images/EDG/SettingsIcon.svg";
import AlertIcon from "images/EDG/AlertIcon.svg";
import LineageIcon from "images/EDG/LineageIcon.svg";
import ExploreIcon from "images/EDG/ExploreIcon.svg";
import ExploreIconWhite from "images/EDG/ExploreIconWhite.svg";
import AIReadyIcon from "images/EDG/AIReadyIcon.svg";
import EditIcon from "images/EDG/EditIcon.svg";
import CheckIcon from "images/EDG/CheckIcon.svg";
import DateIcon from "images/EDG/DateIcon.svg";
import CreateIcon from "images/EDG/CreateIcon.svg";
import HourglassIcon from "images/EDG/hourglass.svg";
import ImportIcon from "images/EDG/ImportIcon.svg";
import FilterIcon from "images/EDG/FilterIcon.svg";
import JoinIcon from "images/EDG/JoinIcon.svg";
import ChangeIcon from "images/EDG/ChangeIcon.svg";
import AibleIcon from "images/EDG/AibleIcon.svg";
import PinIcon from "images/EDG/PinIcon.svg";
import AddIcon from "images/EDG/AddIcon.svg";
import DerivedIcon from "images/EDG/DerivedIcon.svg";
import MagicWandIcon from "images/EDG/MagicWandIcon.svg";
import ScaleIcon from "images/EDG/ScaleIcon.svg";
import CombineIcon from "images/EDG/CombineIcon.svg";
import PinIconWhite from "images/EDG/PinIconWhite.svg";
import ABIcon from "images/EDG/ABIcon.svg";
import reportsIcon from "images/EDG/Charts/reports-icon.svg";
import BlueprintIcon from "images/tileIcons/blueprint.svg";

import DataIcon from "images/database-light.svg";

import SenseJoinIcon from "images/Sense-Icons/JoinIcon.svg";
import SenseAppendIcon from "images/Sense-Icons/AppendIcon.svg";
import SenseDerivedIcon from "images/Sense-Icons/DerivedIcon.svg";
import SenseFilterIcon from "images/Sense-Icons/FilterIcon.svg";
import SenseCustomIcon from "images/Sense-Icons/CustomIcon.svg";

export class LineageItem extends PureComponent {
  render() {
    const { icon, label, subItem, date, details, style, fromDatasetLabel, onClick } = this.props;

    return (
      <div className={styles.lineageItem} style={style ? { ...style } : {}}>
        <div className={styles.lineageIcon}>
          <img src={icon} />
        </div>
        <div className={styles.lineageRight}>
          <div className={styles.normalBold}>{label}</div>
          {details ? <div className={styles.sItem}>{details}</div> : ""}
          <div className={styles.sItem}>{subItem}</div>
          <div className={styles.subItem}>{date}</div>
          {fromDatasetLabel && (
            <div className={styles.subItemDate} onClick={onClick}>
              <img src={DataIcon} style={{ height: "12px" }} />
              {onClick ? (
                <a style={{ marginLeft: "3px" }}>{fromDatasetLabel}</a>
              ) : (
                <span style={{ marginLeft: "3px" }}>{fromDatasetLabel}</span>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default class Lineage extends PureComponent {
  getActiveBlueprint() {
    const { columnBlueprintId, blueprints } = this.props;

    const activeBlueprint = columnBlueprintId && blueprints && blueprints.find((b) => b.id === columnBlueprintId);

    return activeBlueprint;
  }

  renderLineageItem(icon, label, subItem, date, details, mDetails, fromDataset = undefined) {
    const { openAndScrollLineage } = this.props;

    return (
      <div className={styles.lineageItem}>
        <div className={styles.lineageIcon}>
          <img src={icon} />
        </div>
        <div className={styles.lineageRight}>
          {fromDataset !== undefined && openAndScrollLineage !== undefined ? (
            <a
              onClick={() => {
                openAndScrollLineage(fromDataset, "lastUpdates_" + fromDataset?.id);
              }}
            >
              <div className={styles.normalBold}>{label}</div>
            </a>
          ) : (
            <div className={styles.normalBold}>{label}</div>
          )}
          {details ? <div className={styles.sItem}>{details}</div> : ""}
          {mDetails ? <div className={styles.sItem}>{mDetails}</div> : ""}
          <div className={styles.sItem}>{subItem}</div>
          <div className={styles.subItem}>{date}</div>
        </div>
      </div>
    );
  }

  render() {
    const {
      id,
      activeTab,
      dataset,
      combineDataset,
      updateRightMode,
      matchedColumns,
      transform,
      filters,
      lookupKeys,
      dataSourceDetails,
      linkedSchemaChanges,
      linkedSchenaMonitor,
      isLinkedDataset,
      userName,
      senseState,
      schemaMonitors,
      fromDataset,
      openAndScrollLineage
    } = this.props;

    const filterOptions = [
      { label: "Show All", value: "Show All" },
      { label: "Dataset Edits", value: "Dataset Edits" },
      { label: "User Shares", value: "User Shares" },
      {
        label: "Database Connections/Joins",
        value: "Database Connections/Joins"
      }
    ];

    const dataSourceImage = (dataSourceDetails && dataSourceDetails.image) || CreateIcon;
    const dataSourceTable = dataset && dataset.source && dataset.source.content && dataset.source.content.table;
    const dataSourceLabel =
      fromDataset !== undefined
        ? fromDataset?.label + " (" + fromDataset?.id + ")"
        : dataSourceDetails
          ? dataSourceDetails.label
          : "CSV";

    const activeBlueprint = this.getActiveBlueprint();

    const joinPreview = senseState?.JOIN;
    const appendPreview = senseState?.APPEND;
    const customPreview = senseState?.CUSTOM;

    const customText =
      senseState?.CUSTOM?.data !== undefined
        ? Object.keys(senseState?.CUSTOM?.data).reduce((a, b) => a + senseState?.CUSTOM?.data[b]?.columnName + " ", "")
        : undefined;

    const schemaMonitorId = dataset?.source?.content?.schema_monitor_id;

    const schemaMonitor = schemaMonitorId === undefined ? undefined : schemaMonitors?.[schemaMonitorId];

    return (
      <div>
        <div
          className={styles.rightContent}
          style={{
            paddingBottom: "0px",
            paddingLeft: "0px",
            paddingRight: "0px"
          }}
        >
          <div className={styles.lineageList}>
            {this.renderLineageItem(
              AIReadyIcon,
              "Latest Exploratory Analysis Conducted",
              dataset.outcome,
              moment.utc(dataset.updated_date).local().format("MMMM Do YYYY, h:mm:ss a")
            )}
            {linkedSchemaChanges &&
              this.renderLineageItem(
                dataSourceImage,
                "Schema Changed" + (linkedSchenaMonitor ? " at " + linkedSchenaMonitor.name : ""),
                <OverlayTrigger
                  placement="top"
                  trigger={["click"]}
                  rootClose
                  overlay={
                    <Popover id="popover-positioned-top" title={"Database Changes"}>
                      <div className={styles.changesOverlay}>
                        <DatasetSchemaChangesContainer id={id} />
                      </div>
                    </Popover>
                  }
                >
                  <a className={styles.changesTrigger}>
                    {(linkedSchemaChanges.table ? linkedSchemaChanges.table.length : 0) +
                      (linkedSchemaChanges.columns ? linkedSchemaChanges.columns.length : 0) +
                      " change" +
                      ((linkedSchemaChanges.table ? linkedSchemaChanges.table.length : 0) +
                        (linkedSchemaChanges.columns ? linkedSchemaChanges.columns.length : 0) !==
                      1
                        ? "s"
                        : "")}
                  </a>
                </OverlayTrigger>,
                linkedSchenaMonitor
                  ? moment.utc(linkedSchenaMonitor.updated_date).local().format("MMMM Do YYYY, h:mm:ss a")
                  : "",
                dataSourceTable
              )}
            {this.renderLineageItem(
              dataSourceImage,
              "Dataset Created From " + dataSourceLabel,
              dataset.created_by.fullname,
              moment.utc(dataset.created).local().format("MMMM Do YYYY, h:mm:ss a"),
              schemaMonitor?.name,
              dataSourceTable,
              fromDataset
            )}
          </div>
        </div>
      </div>
    );
  }
}
